import { Component, createRef } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import _ from "lodash";
import {
  searchManageUserAction,
  flushManageUserAction,
  addnewUserAction,
  searchManageUserGrid,
  bulkUserUploadRequest,
  addNewUserSelected,
  setColumnExpand,
} from "../../store/actions/manage-user-actions";
import ListUsers from "./listUsers/listUsers";
import t from "../../localization/en/translation.json";
import { ProjectStatus } from "../../components/projectCard/projectCardConstants";
import {
  updateManageUserReset,
  updateManageUser,
  getProjectDetails,
  getProjectUsersList,
  getProjectUsersAccessList,
  flushManageUsersGrid,
  showLoader,
  getProjectUsersListSuccess,
  getProjectActiveFeatures,
} from "../../store/actions/project-actions";
import {
  getAppPlatforms,
  getAppPlatformRoles,
} from "../../store/actions/meta-actions";
import { Link } from "react-router-dom";
import { updateProjectDetailsForEMG } from "../../store/actions/emg-policy-actions";
import { getProjectStatusAction } from "../../store/actions/project-status-actions";
import {
  getAzureAppInsights,
  isProjectAdmin,
  isEyUser,
  isProjectAdminUser,
  setPageBrTitle,
} from "../../utils/helper-utility";
import { checkAndLoadEMGPolicy } from "../../components/emgPolicy/constants";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { AppButton, AppModal, AppIcon, AppMultiActionButton } from "../../theme";
import { magnifyingGlass, xMark } from "../../theme/icons";
import "./manageUsers.scss";
import { CrashBoundary } from "../../components/CrashBoundary";
import { ManageUsersProps, IState } from "./manageUsersModel";
import { RoutePathKeys, SSPRolesEnum, ProjectActiveFeatures } from "../../utils/Constants";
import BreadcrumbComponent from "../../components/breadcrumb/Breadcrumb";
import { IUser } from "../../models/user";
import { showActionToast } from "../../store/actions/notification-actions";
import GridHeaderToolbar from "./gridHeaderToolbar/gridHeaderToolbar";
import { EmailDomains } from "./emailDomains/emailDomains";
import en_translation from "../../localization/en/translation.json";
import { createDomainUser, filterUserList, isAtleastOneAdminUser, handleRemoveUsers, handleUserRoleChange, isValidUserRow, updateDomainDetails, getSuccessMessage, failedDomainUsersAsNew } from "../../utils/manageUserHelpers";
import { exportTemplate, exportUsers } from "../../store/apis/projectApi";
import { EProjectStatuses as EProjectStatus } from "../../utils/Constants";
import ManageUserRoleError from "./manageUserRoleError/manageUserRoleError";
import { ShowBulkRoleAssignment } from "./bulkRoleAssignment/bulkRoleAssignment";
import ImportUserModal from "../../components/importUserModal/importUserModal";
import { IUserRole } from "../../models/IUserAccess";

type RouteParams = { id: string };
type IProps = RouteComponentProps<RouteParams> & ManageUsersProps;

class ManageUsers extends Component<IProps, IState> {
  private handleRedirection: Function;
  bulkImportSaveHandler = false;
  uploadFormData;
  updatedUsersForRole:IUserRole[] = [];
  inputRef = createRef<HTMLInputElement>();
  
  constructor(props: IProps) {
    super(props);
    this.state = {
      searchQuery: "",
      isOpen: false,
      isUserAlreadyExist: false,
      isManageUsersGridUpdated: false,
      showGridUpdateCancelDialog: false,
      nextLocation: null,
      updatedUserRoles: [],
      maxRecordsPerPage: 50,
      currentPage: 1,
      reRenderGrid: true,
      bulkImportTemplateSuccess: false,
      bulkImportTemplateFailure: false,
      bulkImportSaveData: false,
      updatedUsersList: [],
      showDomainsModal: false,
      showBulkRoleAssignModal: false,
      domainUsers: [],
      isSaveAndCloseClicked: false,
      userInputSearch: '',
      isDeleteUserClicked: false,
      failedDomainUsers: []
    };

    this.handleRedirection = () => null;
  }

  componentDidMount() {
    const {
      record,
      updateManageUserReset,
      projectStatuses,
      getProjectStatusAction,
      history,
      match: {
        params: { id },
      },
      getAppPlatforms,
      getProjectDetails,
      getAppPlatformRoles,
      activeFeatures,
      getActiveFeatures,
    } = this.props;

    updateManageUserReset();

    getProjectDetails({
      id,
    });

    getAppPlatformRoles({
      projectId: id,
    });

    getAppPlatforms();

    !projectStatuses?.length && getProjectStatusAction();
    !activeFeatures?.length && getActiveFeatures({ id });

    this.refreshGrid();
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    

    this.handleRedirection = history.block((targetLocation) => {
      const { isManageUsersGridUpdated, showGridUpdateCancelDialog } =
        this.state;
      
      if (isManageUsersGridUpdated && showGridUpdateCancelDialog === false) {
        this.setState(
          {
            ...this.state,
            nextLocation: targetLocation.pathname,
          },
          () => {
            this.toggleCancelDialog(true);
          }
        );
        return false;
      }

      //TODO
      // if(this.checkPlatformRoleAssigned && showPlatformRoleConfirmDialog === false){
      //   this.setState({
      //     ...this.state,
      //     nextLocation: targetLocation.pathname,
      //     showPlatformRoleConfirmDialog: false
      //   });
      //   return false;
      // }

    });

    const appInsights = getAzureAppInsights();
    if (record && record.id && appInsights) {
      appInsights.updateProjectDetails({
        CapitalEdgeProjectFriendlyId: record.projectFriendlyId || "",
      });
    }
    record && record.id && this.updatePageBrTitle();

    this.checkForEMGPolicy();
  }

  componentDidUpdate(prevProps: IProps) {
    const {
      projectUsers,
      updateManageUsersResponse,
      record,
      history,
      match: {
        params: { id },
      },
      userAddRequested,
      usersUpdateRequested,
      removeUserGridDisplay,
      bulkUserUploadErrors,
      addNewSelectedUser
    } = this.props;
    if (!_.isEqual(prevProps.record, record)) {
      if (
        record?.projectStatus?.projectStatusName.toLowerCase() ===
        ProjectStatus.DRAFT
      ) {
        history.push(`/project/${id}`);
      } else {
        this.updatePageBrTitle();
      }
    }
    if (addNewSelectedUser.length > 0 && !_.isEqual(prevProps.addNewSelectedUser, addNewSelectedUser)) {
      const getNewUser = addNewSelectedUser.filter((v) => !this.state.updatedUserRoles.some((role) => role.mail === v.mail));
      this.setState({
        ...this.state,
        updatedUserRoles: [...this.state.updatedUserRoles, ...getNewUser],
        isManageUsersGridUpdated: true,
      });
    }

    if (
      prevProps.removeUserGridDisplay === false &&
      removeUserGridDisplay === true
    ) {
      this.setState({
        ...this.state,
        updatedUserRoles: [],
      });
    }

    if (prevProps.userAddRequested === true && userAddRequested === false) {
      this.refreshGrid();
    }

    if (
      prevProps.usersUpdateRequested === true &&
      usersUpdateRequested === false &&
      updateManageUsersResponse?.appPlatforms?.length
    ) {
      const getSuccessMsg = getSuccessMessage(this.state.isDeleteUserClicked, this.state.updatedUserRoles?.length || 0, updateManageUsersResponse?.failedUsers?.length || 0);
      const checkFailDomain = (this.state.domainUsers?.length > 0 && updateManageUsersResponse?.failedUsers?.length) ? failedDomainUsersAsNew(updateManageUsersResponse?.failedUsers, this.state.updatedUserRoles) : [];
      this.setState(
        {
          ...this.state,
          updatedUserRoles: [],
          failedDomainUsers: checkFailDomain,
          domainUsers: [],
        },
        () => {
          if (
            updateManageUsersResponse?.appPlatforms?.filter((item) => !item.isAllProcessed)
              .length === 0
          ) {
            setTimeout(() => {
              this.props.showActionToast(getSuccessMsg);
              if (this.state.isSaveAndCloseClicked)
                history.push(`/project/${id}`);
            }, 500);
          }
          this.refreshGrid();
        }
      );
    }

    if (!_.isEqual(projectUsers, prevProps.projectUsers)) {
      this.setState({
        reRenderGrid: true,
      });
    }

    if (
      prevProps.bulkUserUploadErrors !== bulkUserUploadErrors &&
      bulkUserUploadErrors?.success &&
      this.bulkImportSaveHandler
    ) {
      this.refreshGrid();
      this.bulkImportSaveHandler = false;
      this.setState({ bulkImportSaveData: true });
    } else if (
      prevProps.bulkUserUploadErrors !== bulkUserUploadErrors &&
      bulkUserUploadErrors?.error &&
      this.bulkImportSaveHandler
    ) {
      this.bulkImportSaveHandler = false;
      this.setState({ bulkImportSaveData: true });
    }

    const appInsights = getAzureAppInsights();
    if (prevProps.record !== record && record && record.id) {
      if (appInsights) {
        appInsights.updateProjectDetails({
          CapitalEdgeProjectFriendlyId: record.projectFriendlyId || "",
        });
      }

      this.checkForEMGPolicy();
    }
  }

  convertB64ToBlob(b64Data: string, type: string): Blob {
    const byteCharacters = atob(b64Data);
    // tslint:disable-next-line:no-any
    const byteArrays = [] as any;
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type });
  }

  createAndDownloadExcelFile(fileContent) {
    if (fileContent) {
      const date = new Date().toDateString();
      const time = new Date().toLocaleTimeString("en-US", {
        timeStyle: "short",
      } as any);

      const blob = this.convertB64ToBlob(fileContent, "application/octet-stream");

      const blobURL =
        window.URL && window.URL.createObjectURL
          ? window.URL.createObjectURL(blob)
          : window.webkitURL.createObjectURL(blob);
      const downloadButton = document.createElement("a");
      downloadButton.style.display = "none";
      downloadButton.href = blobURL;
      downloadButton.setAttribute("download", `Users ${date} ${time}.xlsm`);
      document.body.appendChild(downloadButton);
      downloadButton.click();
      this.setState({ bulkImportTemplateSuccess: true });
      setTimeout(() => {
        document.body.removeChild(downloadButton);
        window.URL.revokeObjectURL(blobURL);
        this.setState({ bulkImportTemplateSuccess: false });
      }, 2000);
    }
  }

  handleBeforeUnload = (e) => {
    if (this.state.isManageUsersGridUpdated) {
      return (e.returnValue = false);
    }
  };

  componentWillUnmount() {
    const { history, resetAddNewUserSelected } = this.props;
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    this.handleRedirection();
    this.props.flushManageUsersGrid();
    resetAddNewUserSelected();
    if (!history.location.pathname.includes(RoutePathKeys.PROJECT)) {
      this.resetPageBrTitle();
    }
    // this.props.fetchSearchData({});
  }

  checkForEMGPolicy = () => {
    const { accessRight, record, updateProjectDetailsForEMGAction } =
      this.props;
    checkAndLoadEMGPolicy(
      accessRight,
      updateProjectDetailsForEMGAction,
      record
    );
  };

  refreshGrid = (searchedUser?: string) => {
    this.setState({
      ...this.state,
      searchQuery: searchedUser || "",
    });

    const {
      match: {
        params: { id },
      },
      getProjectUsersList,
      getProjectUsersAccessList,
    } = this.props;
    
    getProjectUsersList({
      projectId: id,
    });

    getProjectUsersAccessList({
      projectId: id,
      userIds: (searchedUser && [searchedUser]) || [],
    });
  };

  handleUpdateClick = (isSaveAndClose, isDeleteClicked = false) => {
    // Update button click handler
    const {
      updateManageUser,
      showActionToast,
      match: {
        params: { id },
      },
      resetAddNewUserSelected,
      projectUsers,
      projectUserAccess,
      appPlatformRoles
    } = this.props;
    const { updatedUserRoles, domainUsers } = this.state;
    let finalRoles = _.cloneDeep(updatedUserRoles);
    if (
      projectUserAccess?.length > 0 &&
      isAtleastOneAdminUser(projectUserAccess, finalRoles, appPlatformRoles)
    ) {
        showActionToast({ message: t.app_crash_msg, type: 'error'});
        this.setState({ updatedUserRoles: [] });
        return;
    }
    if (domainUsers.length) {
      finalRoles = updateDomainDetails(finalRoles, domainUsers);

    }
    const isBlankDetails = isValidUserRow(finalRoles, projectUsers);
    if (isBlankDetails) {
      showActionToast({
        message: en_translation.manage_user_blank_row,
        type: "warning",
      });
      return;
    }
    const body = {
      projectId: id,
      users: [...finalRoles],
    };
  
    if(!isDeleteClicked){
      this.updatedUsersForRole = finalRoles;
    }
    resetAddNewUserSelected();
    this.setState(
      {
        ...this.state,
        isManageUsersGridUpdated: false,
        isSaveAndCloseClicked: isSaveAndClose ? true : false,
        isDeleteUserClicked: isDeleteClicked,
      },
      () => {
        updateManageUser({
          body,
          projectId: id,
        });
      }
    );
  };

  handleSearchChange = (value) => {
    this.setState(
      {
        ...this.state,
        userInputSearch: value,
        reRenderGrid: true,
        currentPage: 1,
        ...(!value?.trim() && { currentPage: 1 }),
      },
      () => {
        // Restore focus after state update
        setTimeout(() => {
          this.inputRef.current?.focus();
        }, 100);
      }
    );
  };

  handleConfirmForRedirection = () => {
    const { history } = this.props;
    const { nextLocation } = this.state;
    history.push(nextLocation);
  };

  handleAddUserToGrid = (value) => {
    const {
      match: {
        params: { id },
      },
      appPlatformRoles,
      addnewUserAction,
    } = this.props;
    const sspRoles = appPlatformRoles.ssp.roles || [];
    const sspUserRoleRecord = sspRoles.find(
      (item) => item.key === SSPRolesEnum.PRJUSR
    );
    const body = {
      ...value,
      photo: "",
      sspRoleId: sspUserRoleRecord?.id || "",
      roles: [
        {
          projectId: id,
          userRoleId: sspUserRoleRecord?.id || "",
        },
      ],
    };
    addnewUserAction({
      body,
      projectId: id,
    });

    this.setState({
      ...this.state,
      isOpen: false,
    });
  };

  onDomainRowChange = (name, value, rowData) => {
    const getDomainData = createDomainUser(rowData, name, value, this.props.sspPlatformRoles, this.state.domainUsers);
    this.setState({
      ...this.state,
      domainUsers: getDomainData
    });
  };

  handleSearchUser = (value) => {
    const {
      match: {
        params: { id },
      },
    } = this.props;
    this.setState({ isUserAlreadyExist: false });
    this.props.searchUserEmail({
      email: {
        emails: [value],
      },
      projectId: id,
    });
  };

  removeUserFromGrid = (removeUsersData: Array<IUser>) => {
    const { projectUserAccess } = this.props;
    const { updatedUserRoles } = this.state;
    const updatedUsers = handleRemoveUsers(removeUsersData, updatedUserRoles, projectUserAccess);
    this.setState({
      ...this.state,
      updatedUserRoles: [...updatedUsers],
      isManageUsersGridUpdated: true,
      reRenderGrid: false,
    },
      () => {
        this.handleUpdateClick(false, true);
      });
  };

  removeNewUserFromGrid = (updatedUsers) => {
    const { updateUserList, pagination } = this.props;
    const { failedDomainUsers, updatedUsersList, updatedUserRoles } = this.state;
    const updateFailedDomainUsers = failedDomainUsers?.length ? failedDomainUsers.filter(user => !updatedUsersList.some(ru => ru?.mail ?? ru.userDetails?.mail === user.mail)) : [];
    const updatedRoles = updatedUserRoles?.length ? updatedUserRoles.filter((v) => !updatedUsersList.some(ru => ru?.mail ?? ru.userDetails?.mail === v.mail)) : [];
    this.setState({
      ...this.state,
      updatedUserRoles: updatedRoles?.length ? [...updatedRoles] : [],
      isManageUsersGridUpdated: false,
      reRenderGrid: true,
      failedDomainUsers: updateFailedDomainUsers
    },
      () => {
        updateUserList({
          data: {
            records: updatedUsers,
            pagination: pagination,
          },
        });
      });

  }

  toggleCancelDialog = (shown: boolean) => {
    const { showGridUpdateCancelDialog } = this.state;
    if (showGridUpdateCancelDialog !== shown) {
      this.setState({
        ...this.state,
        showGridUpdateCancelDialog: shown,
      });
    }
  };

  onUserRoleChange = (userId: string, platform: string, roles: []) => {
    const { projectUserAccess, appPlatformList, record, projectUsers } =
      this.props;
    const { updatedUserRoles } = this.state;
    const temporaryProjectUserAccess = handleUserRoleChange(
      projectUserAccess,
      appPlatformList,
      record,
      projectUsers,
      updatedUserRoles,
      userId,
      platform,
      roles
    );

    this.setState({
      ...this.state,
      updatedUserRoles: [...temporaryProjectUserAccess],
      isManageUsersGridUpdated: temporaryProjectUserAccess.length > 0,
      reRenderGrid: false,
    });
  };

  updateMaxRecordsPerPage = (count: number) => {
    this.setState(
      {
        ...this.state,
        maxRecordsPerPage: count,
        currentPage: 1,
      });
  };

  onPageChange = (pageNo: number) => {
    this.setState(
      {
        ...this.state,
        currentPage: pageNo,
        reRenderGrid: true,
      });
  };

  canGridLoad = () => {
    const {
      record,
      projectUsers,
      appPlatformList,
      appPlatformRoles,
      projectUserAccess,
    } = this.props;
    if (
      !appPlatformList ||
      (Array.isArray(appPlatformList) && appPlatformList.length === 0)
    ) {
      return false;
    } else if (
      !appPlatformRoles ||
      Object.keys(appPlatformRoles).length === 0 ||
      !appPlatformRoles.ssp ||
      appPlatformRoles.ssp.roles.length === 0 ||
      appPlatformRoles.appPlatforms.length === 0
    ) {
      return false;
    } else if (!projectUserAccess || projectUserAccess.length === 0) {
      return false;
    } else if (!record) {
      return false;
    } else if (
      !projectUsers ||
      (Array.isArray(projectUsers) && projectUsers.length === 0)
    ) {
      return false;
    }

    return true;
  };

  isProjectAdmin = () => {
    const { record, sspPlatformRoles, accessRight } = this.props;
    return isProjectAdmin(record?.id || "", accessRight, sspPlatformRoles);
  };
  isProjectAdminUser = () => {
    const { record, sspPlatformRoles, accessRight } = this.props;
    return isProjectAdminUser(record?.id || "", accessRight, sspPlatformRoles);
  };
  isEyUser = () => {
    return isEyUser(this.props.accessRight);
  };

  bulkImportSave = () => {
    const {
      bulkUserUploadRequest,
      match: {
        params: { id },
      },
    resetAddNewUserSelected
    } = this.props;

    const formData = this.uploadFormData;
    this.bulkImportSaveHandler = true;
    resetAddNewUserSelected();
    this.setState({ bulkImportSaveData: false, updatedUserRoles: [] });
    
    bulkUserUploadRequest({
      projectId: id,
      saveEnabled: true,
      formData,
    });
  };

  validateBulkUserFile = (formData) => {
    const {
      bulkUserUploadRequest,
      match: {
        params: { id },
      },
    } = this.props;

    this.uploadFormData = formData;
    bulkUserUploadRequest({
      projectId: id,
      saveEnabled: false,
      formData,
    });
  };

  updatePageBrTitle() {
    const { record } = this.props;
    if (record && record.name) {
      setPageBrTitle(record.name);
    }
  }

  resetPageBrTitle() {
    setPageBrTitle();
  }

  openDomainModal = () => {
    this.setState({ showDomainsModal: true });
  }

  closeDomainModal = () => {
    this.setState({ showDomainsModal: false });
  }

  openRoleModal = () => {
    this.setState({ showBulkRoleAssignModal: true, isDeleteUserClicked: false });
  }

  closeRoleModal = () => {
    this.setState({ showBulkRoleAssignModal: false });
  }

  handleImportClick = (value) => {
    this.setState({ isOpen: value, bulkImportSaveData: false });
    this.props.flushSearchUserData();
    this.setState({ isUserAlreadyExist: false });
  };

  closeImportModal = () => {
    this.setState({ isOpen: false });
  }

  handleExportClick = async () => {
    const { match: { params: { id } }, showLoader, showActionToast } = this.props;
    showLoader(true);
    try {
      const res = await exportUsers(id);
      this.createAndDownloadExcelFile(res.data.fileContents);
    } catch (error) {
      showActionToast({
        message: en_translation.something_went_wrong,
        type: "error",
      });
    } finally {
      showLoader(false);
    }
  };

  handleExportTemplateClick = async () => {
    const { match: { params: { id } }, showLoader, showActionToast } = this.props;
    showLoader(true);
    try {
      const res = await exportTemplate(id);
      this.createAndDownloadExcelFile(res.data.fileContents);
    } catch (error) {
      showActionToast({
        message: en_translation.something_went_wrong,
        type: "error",
      });
    } finally {
      showLoader(false);
    }
  };

  isProvisioning = () => {
    const { record } = this.props;
    return record?.appPlatformDetails?.some(
      (platformDetail) =>
        platformDetail.statusId ===
        this.props.projectStatuses.find(
          (status) => status.key === EProjectStatus.PND
        )?.id
    );
  }

  render() {
    const {
      record,
      projectUsers,
      projectUserAccess,
      appPlatformList,
      appPlatformRoles,
      match: {
        params: { id },
      },
      pagination,
      projectStatuses,
      updateManageUsersResponse,
      showLoader,
      isColumnExpand,
      resetColumnExpand,
      bulkUserUploadErrors
    } = this.props;

    const {
      currentPage,
      showGridUpdateCancelDialog,
      updatedUserRoles,
      maxRecordsPerPage,
      showDomainsModal,
      showBulkRoleAssignModal,
      isOpen,
      bulkImportSaveData,
      userInputSearch,
      failedDomainUsers,
    } = this.state;
    const breadcrumbObject = [
      { label: t.breadcrumb_title, href: "/", active: true },
      {
        label: `${record?.name}`,
        href: `/project/${record?.id}`,
        active: true,
      },
      {
        label: t.step_three_title,
        href: "",
        active: false,
        disabled: true,
      },
    ];

    const isUserProjectAdmin = this.isProjectAdmin();
    const isProjectAdminUser = this.isProjectAdminUser();
    const isEyUser = this.isEyUser();
    const { projectUsersList, gridPagination } = filterUserList(projectUsers, maxRecordsPerPage, currentPage, userInputSearch, pagination, failedDomainUsers) || {};


    const activeAppPlatformRoles = {
      ...appPlatformRoles,
      ssp: {
        // eslint-disable-next-line
        roles: appPlatformRoles.ssp.roles.filter(role => {
          if (role.key === SSPRolesEnum.PRJUSRAIDISABLED) {
            if (this.props.activeFeatures?.includes(ProjectActiveFeatures.MANAGE_ASSISTANT))
              return role;
          } else {
            return role;
          }
        })
      }
    };

    if (record && record.id) {
      return (
        <CrashBoundary>
          <div className="manage-users">
            <div className="manage-header">
              <div className="title-wrapper">
                <BreadcrumbComponent
                  items={breadcrumbObject}
                ></BreadcrumbComponent>
              </div>
            </div>
            <div className="content">
              <div className="grid-title">
                <span className="title">{t.manage_user_page_title}</span>
                <div className="search-wrapper">
                  <div className="search-input-wrapper">
                    <AppIcon icon={magnifyingGlass} className="search-box-icon" />
                    {userInputSearch ? <AppIcon icon={xMark} className="clear-icon" onClick={() => this.handleSearchChange('')} /> : null}
                    <input
                      name={'manageUserSearch'}
                      className="search-input-field"
                      value={userInputSearch}
                      onChange={(e) => this.handleSearchChange(e.target.value)}
                      placeholder="Search"
                      ref={this.inputRef}
                      autoComplete="off"
                    />
                  </div>
                  
                  <div className="btn-wrapper">
                    <Link to={`/project/${id}`} className="btn">
                      <AppButton color="secondary" className="update-btn">{t.Close}</AppButton>
                    </Link>
                    <AppMultiActionButton
                      actions={[
                        {
                          label: t.manage_user_save_and_close, onClick: () => {
                            this.handleUpdateClick(true);
                          }
                        },
                        { label: t.save, onClick: () => this.handleUpdateClick(false) },
                      ]}
                      disabled={!updatedUserRoles?.length}
                      containerId="manage-user-action-btn"
                    />
                  </div>
                </div>
              </div>
              <ManageUserRoleError
                canGridLoad={this.canGridLoad()}
                updateManageUsersResponse={updateManageUsersResponse}
              />
              <div className="manage-users-wrapper">
                <GridHeaderToolbar
                  isUserProjectAdmin={isUserProjectAdmin}
                  isProjectAdminUser={isProjectAdminUser}
                  onRemoveUserClick={() => this.removeUserFromGrid(this.state.updatedUsersList)}
                  updatedUsersList={this.state.updatedUsersList}
                  gridUpdatedUserRoles={updatedUserRoles}
                  onSaveClick={() => this.handleUpdateClick(false)}
                  onDomainClick={this.openDomainModal}
                  projectId={id}
                  onExportUserClick={this.handleExportClick}
                  onExportTemplateClick={this.handleExportTemplateClick}
                  isProvisioning={this.isProvisioning()}
                  removeNewUserFromGrid={this.removeNewUserFromGrid}
                  onBulkRoleAssignClick={this.openRoleModal}
                  onImportClick={() => this.handleImportClick(true)}
                  clearSearchFilter={() => this.handleSearchChange('')}
                />
                <div className="manage-users-grid-wrapper">
                  <ListUsers
                    isProjectAdmin={isUserProjectAdmin}
                    isProjectAdminUser={isProjectAdminUser}
                    isEyUser={isEyUser}
                    projectStatuses={projectStatuses}
                    onPageChange={this.onPageChange}
                    currentPage={currentPage}
                    onUpdateMaxRecordsPerPage={this.updateMaxRecordsPerPage}
                    maxRecordsPerPage={maxRecordsPerPage}
                    pagination={gridPagination}
                    onRoleChange={this.onUserRoleChange}
                    updatedUserAccess={updatedUserRoles}
                    platformRoles={activeAppPlatformRoles}
                    appPlatformList={appPlatformList}
                    project={record}
                    projectAppList={record?.appDetails || []}
                    projectAppPlatformList={record?.appPlatformDetails || []}
                    userAccess={projectUserAccess}
                    users={projectUsersList}
                    reRender={this.state.reRenderGrid}
                    setLoader={showLoader}
                    onRowSelectChange={(data) =>
                      this.setState({ updatedUsersList: data })
                    }
                    onDomainRowChange={this.onDomainRowChange}
                    domainUsers={this.state.domainUsers}
                    isColumnExpand={isColumnExpand}
                    resetColumnExpand={() => resetColumnExpand(false)}
                  />
                </div>
              </div>
            </div>

            {isOpen && (
              <ImportUserModal
                isOpen={isOpen}
                bulkImportTemplatedownload={this.handleExportTemplateClick}
                bulkUserUploadRequest={this.validateBulkUserFile}
                closeImportModal={this.closeImportModal}
                bulkUserUploadErrors={bulkUserUploadErrors}
                bulkImportSave={this.bulkImportSave}
                bulkImportSaveData={bulkImportSaveData}
              />
            )}

            <AppModal
              showModal={showGridUpdateCancelDialog}
              confirmBtnText={t.manage_users_cancel_continue_btn}
              onConfirm={this.handleConfirmForRedirection}
              cancelBtnText={t.cancel}
              confirmBtnClass="warning"
              onModalClose={() => this.toggleCancelDialog(false)}
              size="sm"
              title={t.manage_users_cancel_dialog_title}
            >
              {t.manage_users_cancel_redirect_message}
            </AppModal>

            <AppModal
              showModal={showDomainsModal}
              hideFooterSection={true}
              onModalClose={this.closeDomainModal}
              size="md"
              title={t.email_domains_title}
              modalClass="email-domains-modal"
            >
              <EmailDomains
                record={record}
                closeDomainModal={this.closeDomainModal}
                projectUsersList={projectUsersList}
              />
            </AppModal>

            <AppModal
              showModal={showBulkRoleAssignModal}
              hideFooterSection={true}
              onModalClose={this.closeRoleModal}
              size="md"
              title={t.bulk_assign_roles_title}
              modalClass="bulk-role-assign-modal"
            >
              <ShowBulkRoleAssignment
                record={record}
                closeRoleModal={this.closeRoleModal}
                platformRoles={activeAppPlatformRoles}
                users={this.state.updatedUsersList}
                updateManageUsersResponse={updateManageUsersResponse}
                projectAppList={record?.appDetails || []}
                appPlatformList={appPlatformList}
                projectStatuses={projectStatuses}
                projectAppPlatformList={record?.appPlatformDetails || []}
                isProjectAdmin={isUserProjectAdmin}
                isProjectAdminUser={isProjectAdminUser}
                isEyUser={isEyUser}
                updateManageUser={this.props.updateManageUser}
                updateManageUserReset={this.props.updateManageUserReset}
                showLoader={this.props.showLoader}
              />
            </AppModal>

            {/* TODO */}
            {/* <AppModal
              showModal={showPlatformRoleConfirmDialog}
              confirmBtnText={t.role_not_assign_model_yes_button}
              onConfirm={this.handlePlatformRoleConfirmForRedirection}
              cancelBtnText={t.role_not_assign_model_no_button}
              confirmBtnClass="warning"
              onModalClose={() => this.togglePlatformRoleCancelDialog(false)}
              size="sm"
            >
              {t.manage_user_role_not_assign_alert_message}
            </AppModal> */}
          </div>
        </CrashBoundary>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = ({
  meReducer,
  projectStatusReducer,
  projects: {
    userAccessRequested,
    usersRequested,
    updateManageUsersResponse,
    usersUpdateRequested,
    record,
    users,
    userAccess,
    userGridPagination,
    userAddRequested,
    removeUserGridDisplay,
  },
  manageUserReducer,
  meta: { appPlatforms, roles, rolesRequested, userRoles, projectStatuses },
  dataLocationsReducer,
  projects
}) => {
  return {
    record,
    projectUsers: users,
    manageSearchUserData: manageUserReducer.manageSearchUserData,
    apiPassSuccess: manageUserReducer.apiPassSuccess,
    loading: manageUserReducer.loading,
    projectUserAccess: userAccess,
    appPlatformList: appPlatforms,
    appPlatformRoles: roles,
    pagination: userGridPagination,
    userAddRequested: userAddRequested,
    usersUpdateRequested: usersUpdateRequested,
    rolesRequested: rolesRequested,
    projectStatuses: projectStatuses || projectStatusReducer.projectStatus,
    accessRight: meReducer.accessRight,
    currentUser: meReducer.currentUser,
    sspPlatformRoles: userRoles,
    updateManageUsersResponse: updateManageUsersResponse,
    usersRequested,
    userAccessRequested,
    removeUserGridDisplay: removeUserGridDisplay,
    bulkUserUploadErrors: manageUserReducer.bulkUserUploadErrors,
    addNewSelectedUser: manageUserReducer.addNewUserSelected,
    manageUserLanguage: manageUserReducer.userLanguage,
    projectCountries: dataLocationsReducer.projectCountries,
    isColumnExpand: manageUserReducer.isColumnExpand,
    activeFeatures: projects.activeFeatures,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getProjectUsersAccessList: (payload) => {
      dispatch(getProjectUsersAccessList(payload));
    },
    getAppPlatforms: (payload) => {
      dispatch(getAppPlatforms(payload));
    },
    getProjectDetails: (payload) => {
      dispatch(getProjectDetails(payload));
    },
    getProjectUsersList: (payload) => {
      dispatch(getProjectUsersList(payload));
    },
    searchUserEmail: (payload) => {
      dispatch(searchManageUserAction(payload));
    },
    flushSearchUserData: () => {
      dispatch(flushManageUserAction());
    },
    addnewUserAction: (payload) => {
      dispatch(addnewUserAction(payload));
    },
    getAppPlatformRoles: (payload) => {
      dispatch(getAppPlatformRoles(payload));
    },
    updateManageUser: (payload) => {
      dispatch(updateManageUser(payload));
    },
    fetchSearchData: (payload) => {
      dispatch(searchManageUserGrid(payload));
    },
    getProjectStatusAction: (payload) => {
      dispatch(getProjectStatusAction(payload));
    },
    updateManageUserReset: () => {
      dispatch(updateManageUserReset());
    },
    bulkUserUploadRequest: (payload) => {
      dispatch(bulkUserUploadRequest(payload));
    },
    updateProjectDetailsForEMGAction: (payload) => {
      dispatch(updateProjectDetailsForEMG(payload));
    },
    showLoader: (payload) => {
      dispatch(showLoader(payload));
    },
    updateUserList: (payload) => {
      dispatch(getProjectUsersListSuccess(payload));
    },
    flushManageUsersGrid: () => dispatch(flushManageUsersGrid()),
    showActionToast: (payload) => dispatch(showActionToast(payload)),
    resetAddNewUserSelected: () => dispatch(addNewUserSelected([])),
    resetColumnExpand: () => dispatch(setColumnExpand(false)),
    getActiveFeatures: (id) => dispatch(getProjectActiveFeatures(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);
